import React from 'react';
import './link-to-slash.css';
import { Link } from 'react-router-dom';


let LinkToSlash = () => {
  return (
    <div id="lts-d1a">
      <Link to="/"
            id="lts-l1a"
      >
        slash
      </Link>
    </div>
  );
};

export default LinkToSlash;


// WEBPACK FOOTER //
// ./src/containers/engage/links/LinkToSlash.js